module.exports = __webpack_public_path__ + "static/media/commercial_mortgage_lending_program.c789b4e8.png";